module.exports = __webpack_public_path__ + "static/media/logo_respira_intro.65fc3a98.png";